"use client";
import React from "react";
import { useLocation } from "react-router-dom";
import ScriptForm from "../../../global/view/new-script-form.jsx";

export default function OTCMedication() {
  const location = useLocation();
  const {
    preselectedPatient = "",
    preselectedPractitioner = "",
    preselectedPaymentType = "",
    disablePatient = false,
    disablePractitioner = false,
  } = location.state || {};

  return (
    <ScriptForm
      title="OTC Dispense"
      showPatient={true}
      showPractitioner={true}
      showScriptNumber={false}
      showPaymentType={true}
      showMedicalAidNumber={false}
      showChronic={false}
      showRepeat={false}
      showMedicationSection={true}
      showPricingSection={true}
      skipProfilePractitionerPrefill={true}
      initialPatient={preselectedPatient}
      initialPractitioner={preselectedPractitioner}
      initialPaymentType={preselectedPaymentType}
      disablePatient={disablePatient}
      disablePractitioner={disablePractitioner}
      inventoryDepartmentId={4}
    />
  );
}
